/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function isHTML(str) {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}
export default function CourseFeatures({
  heading, subheading, courseFeatures, pageName, borderCourse,
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  if (!mounted) return null;
  return (
    <section className={`w-full ${pageName !== 'courseDetail' ? 'bg-[#d2e9ff30] px-[30px] sm:px-[38px] md:px-[46px] py-[30px] sm:py-[38px] md:py-[46px] sm:mt-[20px] md:mt-[10px]' : ''}  flex flex-col items-center gap-4 lg:gap-8`}>

      <header className={`${pageName === 'courseDetail' ? 'item-start w-full' : 'items-center'} flex flex-col lg:gap-[6px]`}>
        <div className="flex items-center gap-3">
          {pageName !== 'courseDetail' && <div className="w-[6px] h-[32px] bg-[#ff5761]" /> }
          <h2 className={`${pageName === 'courseDetail' ? 'lg:text-lg text-base font-semibold' : 'text-[22px] font-medium'}  leading-[33px] text-black`}>
            {heading}
          </h2>
        </div>
        <h3 className="text-[30px]  font-semibold leading-[45px] text-black text-center">
          {subheading}
        </h3>
      </header>

      <div className={`${pageName !== 'courseDetail' ? 'max-w-[1318px]' : ''} w-full  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:gap-[34px] gap-3.5`}>
        {courseFeatures?.map((feature, index) => (
          <div
            key={index}
            className={`relative flex items-center lg:flex-col flex-row  w-full bg-white shadow-[2px_2px_14px_0px_#E4F5FF] ${borderCourse || 'border shadow-sm'} border-[#b7e5ff] rounded-[10px]  px-[14px] py-[24px] text-center`}
          >
            <div className="lg:w-auto w-[20%] lg:flex lg:justify-center">
              <div className={`${pageName !== 'courseDetail' ? 'absolute' : 'relative'} lg:absolute lg:-top-[23px] flex items-center justify-center w-[64px] h-[64px] rounded-full bg-[#38AFFF] shadow-[-1px_3px_7px_#9ad6ff93] border-2 border-white`}>
                <img src={feature?.image} alt={feature?.name} className="w-10 h-10" />
              </div>
            </div>
            <div className="lg:w-auto w-[80%] lg:text-center text-start ps-3">
              <h4 className="lg:mt-[40px] text-[16px]  font-semibold leading-[24px] text-black">
                {feature?.name}
              </h4>
              <p className="mt-2 text-[14px]  font-[300] leading-6 text-[#202020]">
                {feature?.description && isHTML(feature.description) ? (
                  <span dangerouslySetInnerHTML={{ __html: feature.description }} />
                ) : feature?.description || ''}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

CourseFeatures.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  courseFeatures: PropTypes.array,
  pageName: PropTypes.string,
  borderCourse: PropTypes.any,
};
